import {Component, EventEmitter, Input, Output} from "@angular/core";
import {AuthService} from "../../services/auth.service";
import {RootShareService} from "../../services/root.shared.service";
import {Moment} from "moment";
import * as moment from "moment";
import * as _ from "lodash";
import {TimelineElementType} from "../patient-timeline-element/patient-timeline-element.component";
import {CustomFormsService} from "../../services/custom.forms.service";
import {VteForm} from "../../models/forms/vte/vte.form";
import {ChecklistForm} from "../../models/forms/checkilst/checklist.form";
//import any = jasmine.any;

@Component({
    selector: 'checklist-element-component',
    templateUrl: './checklist.element.component.html',
    styleUrls: ['../form-element/form.element.component.scss']
})
export class ChecklistElementComponent {
    @Input() type: TimelineElementType = TimelineElementType.vitals;
    @Input() title: string = "Surgical Safety Checklist";
    @Input() firstIcon: string = "";
    @Input() secondIcon: string = "";

    @Input() parent: any;

    @Input() userThumbnail: boolean = false;
    @Input() showDateBalloon: boolean = false;
    @Input() userThumbnailName: string = "John Doe";
    @Input() userThumbnailTitle: string = "5 hours ago";
    @Input() userThumbnailImage: string = "../../assets/img/users_photo/male/christopher.png";

    //Clinical Image
    @Input() patient: any;
    @Input() patientDocument: any;

    @Output() firstIconAction = new EventEmitter();
    @Output() secondIconAction = new EventEmitter();

    @Input() checklistForm: ChecklistForm = new ChecklistForm();

    expandedFlags: any = {
        _parent: null, //FormElementComponent
        _stage1: false,
        get stage1(): boolean { return this._stage1; },
        set stage1(v: boolean) { this._stage1 = v; },
        _stage2: false,
        get stage2(): boolean { return this._stage2; },
        set stage2(v: boolean) { this._stage2 = v; },
        _stage3: false,
        get stage3(): boolean { return this._stage3; },
        set stage3(v: boolean) { this._stage3 = v; },
    };

    addMenuVisible = false;

    constructor(private _rootShareService: RootShareService, private _customFormsService: CustomFormsService, private _auth: AuthService) {
        this.expandedFlags._parent = this;
    }

    getClasses(icon) {
        let classes: Array<string> = [];

        classes.push("unity-icon");
        classes.push("timeline-icon");

        if (icon == 'first')
            classes.push(this.firstIcon);
        else if (icon == 'second')
            classes.push(this.secondIcon);

        return classes;
    }

    userThumbnailDate() {
        let d = moment(this.checklistForm.when);
        let day = d.format('DD');
        let month = d.format('MMM');
        let year = d.format('Y');

        return day + " " + month + " " + year;
    }

    getMonth() {
        // noinspection all
        let month = moment(this.checklistForm.when).format('MMM').toUpperCase();
        return month;
    }

    getYear() {
        // noinspection all
        let year = moment(this.checklistForm.when).format('Y');
        return year;
    }

    /////

    isReadOnly() {
        return !(this.checklistForm.status === 'new' || this.checklistForm.status === 'edit');
    }

    saveElement() {
        // noinspection all
        // let formToSave = _.cloneDeep(this.referralForm);
        // // FIXME: !!!!!
        // formToSave.status = "save";
        this.checklistForm.status = "save";

        // TODO: PUBLISH at some point !!!
        // this._customFormsService.saveForm(formToSave).then((v) => {
        //     // alert(v);
        // });
        this._customFormsService.saveForm(this.checklistForm).then((v:any) => {
            this.checklistForm._id = v._id;
            if (this.parent) {
                // this.parent.updateElements();
            }
        });
    }

    editElement() {
        this.checklistForm.status = "edit";
        if (this.parent) {
            // this.parent.updateElements();
        }
    }

    cancelElement() {
        if (this.parent) {
            this.parent.cancelElement(this.checklistForm);
        }
    }

    removeElement() {
        if (this.parent) {
            this.parent.removeCL(this.checklistForm);
        }
    }

    createElementDOR() {
        // noinspection all
        let formToSave = _.cloneDeep(this.checklistForm);
        delete formToSave._id;
        formToSave.status = "closed_dor";
        formToSave.workflow = "disabled";

        this._customFormsService.saveForm(formToSave).then((v) => {
            if (this.parent) {
                this.parent.addVteElement(formToSave);
                // this.parent.updateElements();
            }
            this.checklistForm.when = moment().toDate();
            this.saveElement();
        });
    }

    createElementDORAndClose() {
        // FIXME: !!!!!
        this.checklistForm.status = "closed";
        this.checklistForm.workflow = "disabled";

        // TODO: PUBLISH at some point !!!
        this._customFormsService.saveForm(this.checklistForm).then((v) => {
            if (this.parent) {
                // this.parent.updateElements();
            }
        });
    }
}
